import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Observable, Subject } from 'rxjs'
import { config } from '../config';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class UserTimeSheetService {
  private isPdf = new Subject<any>();
  private pdfDownload = new Subject<any>();
  constructor(public http: HttpClient) { }


  /**
   * added new timelog method
   * *************************************************************
   */



  addTimelog(data: any): Observable<any> {
    console.log("Adding Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "user-timelog", data).subscribe((res: any) => {

        observer.next(res.data);
        console.log("response from service for timelog", res);

        // observer.complete();
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is timelog")
          observer.complete();
        })

    });
  }

  getJobByInstructorId(instructorId): Observable<any> {
    console.log("Getting jobs");
    let that = this;
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "user-timelog/jobs?_id=" + instructorId).subscribe((res: any) => {
        console.log("Get Jobs... : ", res);
        observer.next(res.data);
        observer.complete();
      })
    });
  }

  /**
   * ***********************************************
   * Get Timelog method   ***************************
   */

  getTimelog(data: any): Observable<any> {
    console.log("Adding Time", data);
    return new Observable<any>((observer) => {
      console.log("Observable get time log");
      var that = this;
      this.http.get(config.baseApiUrl + "user-timelog?_id=" + data).subscribe((res: any) => {

        console.log("response from service for timelog", res);
        observer.next(res);

        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED response is timelog")
          observer.complete();
        })

    });
  }




  generateWeekReport(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "user-timelog/weekreport/pdf", data).subscribe((res: any) => {
        observer.next(res.data);
        this.isPdf.next(true)
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  pdfDownloadCompleted(): Observable<any> {
    return this.isPdf.asObservable();
  }


  getFatigueIndex(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.get(config.baseApiUrl + "fatigue/fatigue-index?_id=" + data).subscribe((res: any) => {
        observer.next(res.data);
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  generateReport(type, format) {
    console.log("How much time it is called");
    this.pdfDownload.next({ type: type, format: format })
  }


  downLoadReportPdf(): Observable<any> {
    return this.pdfDownload.asObservable();
  }



  downloadTimesheet(data) {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.get(config.baseApiUrl + "labourjob/download-excel-time-sheet/?start_date=" + data).subscribe((res: any) => {
        observer.next(res);
        console.log("response from service", res);
      }, err => {
        console.log("ERROR ", err)
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  addCommentforLog(commentData): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", commentData);
      this.http.post(config.baseApiUrl + "user-timelog/comment", commentData).subscribe((res: any) => {
        observer.next(res);
        console.log("response from service", res);
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }



  generateExpenseReport(data): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", data);
      this.http.post(config.baseApiUrl + "user-timelog/expense-report", data).subscribe((res: any) => {
        observer.next(res.data);
        // this.isPdf.next(true)
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });
  }

  covertDateFormate(date, format) {
    console.log("date", date, moment(date, 'DD/MM/YYYY').format('MM/DD/YYYY'))
    return moment(date, 'DD/MM/YYYY').format('MM/DD/YYYY');
  }


  downloadStaffReport(dates): Observable<any> {
    return new Observable<any>((observer) => {
      console.log("html in data in service", dates);
      this.http.get(config.baseApiUrl + "user-timelog/all-staff-report?dates=" + JSON.stringify(dates)).subscribe((res: any) => {
        observer.next(res.data);
        // this.isPdf.next(true)
        console.log("response from service", res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }
}
